import React from 'react';

const CordIcon: React.FC = () => {
  return (
    <svg viewBox="0 0 256 24">
      <path
        className="cls-1"
        d="M0 9.23h155.15v4.35H0zM186.52 9.23h36.38v4.35h-36.38z"
        fill="#314682"
      />
      <path
        d="M229.9 6.55h-5.25a2 2 0 0 0-1.75 2.22V14a2 2 0 0 0 1.75 2.22h5.25Z"
        fill="#2a356d"
      />
      <path
        className="cls-1"
        fill="#314682"
        d="M243.65 1.93h-10.3c-1.9 0-3.43 1.94-3.43 4.33v10.29c0 2.39 1.53 4.33 3.43 4.33h10.3Z"
      />
      <path
        d="M236 12.25c-3-3-2.63-10.32-2.63-10.32-1.89 0-3.43 1.94-3.43 4.33v10.29c0 2.39 1.54 4.33 3.43 4.33h10.3v-4.33a19.65 19.65 0 0 1-7.67-4.3Z"
        fill="#2d3775"
      />
      <path fill="#3d4c8d" d="M243.67.47h2.46v21.86h-2.46z" />
      <path
        className="cls-5"
        fill="#2c2d4f"
        d="M246.12 4.8h8A1.86 1.86 0 0 1 256 6.66v.06a1.86 1.86 0 0 1-1.86 1.86h-8V4.8h-.02ZM246.12 14.23h8a1.86 1.86 0 0 1 1.88 1.86v.06a1.86 1.86 0 0 1-1.86 1.85h-8v-3.77h-.02Z"
      />
      <rect
        className="cls-6"
        x="161.6"
        y="8.03"
        width="3.32"
        height="3.37"
        rx="1.66"
        ry="1.66"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
        stroke="#2c2d4f"
      />
      <rect
        className="cls-7"
        x="159.06"
        y="17.74"
        width="2.05"
        height="2.08"
        rx="1.02"
        ry="1.02"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill="none"
        stroke="#2c2d4f"
      />
      <rect
        className="cls-8"
        x="179.34"
        y="5.12"
        width="1.41"
        height="1.43"
        rx=".7"
        ry=".7"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill="none"
        stroke="#2c2d4f"
      />
      <rect
        className="cls-7"
        x="177.88"
        y="14.5"
        width="2.59"
        height="2.63"
        rx="1.3"
        ry="1.3"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill="none"
        stroke="#2c2d4f"
      />
      <path
        className="cls-8"
        d="m162.6 1.93-.73.02-.39.63-.25-.7-.7-.19.57-.45-.04-.74.6.41.68-.27-.2.72.46.57z"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill="none"
        stroke="#2c2d4f"
      />
      <path
        className="cls-6"
        strokeWidth="1"
        strokeMiterlimit="10"
        fill="none"
        stroke="#2c2d4f"
        d="M172.07 21.71h1.81M175.69 21.71h1.8M174.78 18.95v1.84M174.78 22.63v1.84"
      />
      <path
        className="cls-7"
        strokeWidth="1"
        strokeMiterlimit="10"
        fill="none"
        stroke="#2c2d4f"
        d="M163.64 16.34h1.81M167.26 16.34h1.81M166.36 13.58v1.84M166.36 17.26v1.84"
      />
      <path
        className="cls-8"
        d="M172.65 4.87h1.81M176.26 4.87h1.81M175.36 2.11v1.84M175.36 5.79v1.83"
      />
    </svg>
  );
};

export default CordIcon;
